import {ref} from 'vue'
import axios from 'axios'
import {log} from "@/composables/useLog"
import {BASE_URL} from "@/composables/url_config";
  const error = ref(null)
export const addNewClient = async (token, form) => {
    log("welcome in addNewClient cu parametrii " )
    log("token")
    log(token)
    const API_URL =`${BASE_URL}/home/addNewClientApi`;
    error.value = null
    try {
        error.value = null
        const headers= {
            'Content-Type': 'application/json',
            'Authorization':`Bearer ${token}`
        }

        const data = {
            parent_id: form.newClientParentId,
            newClientName: form.newClientName,
            newClientShortName: form.newClientShortName,
            newClientRegistrationCode:form.newClientRegistrationCode,
            newClientCUI:form.newClientCUI,
            newClientBank:form.newClientBank,
            newClientIBAN:form.newClientIBAN,
            newClientRepresentativeName: form.newClientRepresentativeName,
            client_type_id: form.newClientTypeID,
            newClientAddress: form.newClientAddress,
            newClientCityID: form.newClientCity,
            newClientCountyID: form.newClientCounty,
            newClientCountryID: form.newClientCountry,
            client_status_id:1,
            max_credit: form.newClientMaxCredit,
            phone: form.newClientPhone,
            email: form.newClientEmail,
            notification_email: form.newClientNotificationEmail,
            deleted: form.deleted,
            deleted_at: form.deleted_at,
            deleted_by_user_id: form.deleted_by_user_id,
            created_at: form.created_at,
            updated_at: form.updated_at,
            app_id: form.app_id,
            billing_type_id: form.newClientBillingTypeID,
            legal_type: form.newClientLegalTypeID,
            is_distributor: form.isDistributor || false
        };
        const result = await axios.post(API_URL, data, { headers });
        log("parameters data send:")
        log(data)
        error.value = null
        log ("result.data=");
        log (result.data);
        if(result.data.error==true){
            // alert(result.data.message)
        }
        return result.data
    } catch (err){
        log("am intrat pe la catch (err) in addNewClient")
        log(err.value)
        error.value=err.value
    }
}

const useAddNewClient = () => {
        return { addNewClient };
}
export default useAddNewClient
